export default __webpack_public_path__ + "static/media/papers.68b75833.svg";